import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { range } from 'ramda';
import { motion, useViewportScroll, useAnimation } from 'framer-motion';
import { sizes } from 'style';
import lerp from 'lerp';
import Feather from 'products/global/assets/img/home/feather.png';

const NUM_FEATHERS = 12;

const RANDOMS = range(0, NUM_FEATHERS * 4).map(() => Math.random());
const getRandom = (i) => RANDOMS[i % RANDOMS.length];

const FeathersContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
`;

const FeatherImg = styled(motion.img)`
  position: absolute;
  top: 0;
  left: 0;
  width: ${({ custom }) => lerp(50, 100, getRandom(custom + 20))}px;
  min-width: 5%;

  @media ${sizes.tabletPortrait} {
    width: ${({ custom }) => lerp(60, 120, getRandom(custom + 20))}px;
  }

  @media ${sizes.desktop} {
    width: ${({ custom }) => lerp(80, 200, getRandom(custom + 20))}px;
  }
`;

const Feathers = () => {
  const ref = useRef(null);
  const { scrollY } = useViewportScroll();
  const controls = useAnimation();

  useEffect(() => {
    const getElTop = () =>
      (ref?.current?.parentElement?.offsetTop || 0) - window.innerHeight / 2;

    const getRotation = (i) => (window.pageYOffset * getRandom(i + 40)) / 2;

    const getX = (i) => (window.innerWidth / NUM_FEATHERS) * i;

    const getY = (i, offset = -scrollY.get()) =>
      offset + getElTop() + lerp(-400, 400, getRandom(i));

    controls.start((i) => {
      return {
        rotate: getRotation(i),
        y: getY(i, 0),
        x: getX(i),
        transition: { ease: 'easeOut' }
      };
    });

    const unsubscribeScroll = scrollY.onChange((latestY) => {
      controls.set((i) => ({
        rotate: getRotation(i),
        y: getY(i, -latestY),
        x: getX(i)
      }));
    });
    return () => {
      unsubscribeScroll();
    };
  }, [controls, scrollY, ref]);

  return (
    <FeathersContainer ref={ref}>
      {range(0, NUM_FEATHERS).map((i) => (
        <FeatherImg src={Feather} alt="feather" key={i} custom={i} animate={controls} />
      ))}
    </FeathersContainer>
  );
};

export default Feathers;
